import { render, staticRenderFns } from "./AppForms.vue?vue&type=template&id=6649fdde&scoped=true&"
import script from "./AppForms.vue?vue&type=script&lang=js&"
export * from "./AppForms.vue?vue&type=script&lang=js&"
import style0 from "./AppForms.vue?vue&type=style&index=0&id=6649fdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649fdde",
  null
  
)

export default component.exports